export default "__VITE_ASSET__CoaE6Oyn__"